import type { ComponentProps } from "react";
import Trigger from "./Trigger/Trigger";
import Content from "./Content/Content";
import { Menu } from "@ark-ui/react";
import Item from "./Item/Item";
import TriggerItem from "./TriggerItem/TriggerItem";

type Props = ComponentProps<typeof Menu.Root>;

const DropdownRoot = ({ children, ...rest }: Props) => {
  return <Menu.Root {...rest}>{children}</Menu.Root>;
};

export const Dropdown = Object.assign(DropdownRoot, {
  Trigger,
  Content,
  Item,
  TriggerItem,
});
